export let sliderConfig = null;

export function setSliderConfig(config) {
  sliderConfig = config;

  try {
    localStorage.setItem('sliderConfig', JSON.stringify(config));
  } catch (e) {
    console.warn('No se pudo guardar sliderConfig en localStorage:', e);
  }
}

export function getSliderConfig() {
  try {
    const raw = localStorage.getItem('sliderConfig');
    if (raw) {
      sliderConfig = JSON.parse(raw);
    } else {
      throw new Error('No hay config en localStorage');
    }
  } catch (e) {
    console.warn('No se pudo acceder a sliderConfig desde localStorage. Usando valores por defecto:', e);
    sliderConfig = {
      votos_base: 0,
      votos_euro: 3,
      boost_euro: 0.5
    };
  }

  return sliderConfig;
}
